import styles from './hero-container.module.scss';
import classNames from 'classnames';
import { Logo } from '../logo/logo';
import { HeroImage } from '../hero-image/hero-image';

export interface HeroContainerProps {
    className?: string;
}

/**
 * This component was created using Codux's Default new component template.
 * To create custom component templates, see https://help.codux.com/kb/en/article/configuration-for-hero-containers-and-templates
 */
export const HeroContainer = ({ className }: HeroContainerProps) => {
    return (
        <div className={classNames(styles.root, className)}>
            <HeroImage />
            <Logo />
        </div>
    );
};
